import React, { useEffect, useState } from 'react';
import ReactCountUp from 'react-countup';
import { abbreviateNumber } from 'utils/helper';

const NumberCountUp = ({
  value,
  decimals,
  abbreviate,
  ...others
}) => {
  const [range, setRange] = useState([0, 0]);
  const [start, end] = range;

  useEffect(() => {
    if (value) {
      setRange(old => [old[1], value]);
    }
  }, [value]);

  const rest = Object.assign({}, others || {});
  if (abbreviate) {
    rest.formattingFn = v => (rest.prefix || '') + abbreviateNumber(v);
  }

  if (value === null || value === undefined) {
    return null;
  }

  return (
    <ReactCountUp
      {...rest}
      start={start}
      end={end}
      decimals={
        decimals !== undefined ? decimals : end < 0 ? 4 : end > 1e5 ? 0 : 3
      }
      duration={1}
      separator=","
    />
  );
};

export default NumberCountUp;
